import { render, staticRenderFns } from "./lineTable.vue?vue&type=template&id=28d85eca&scoped=true&"
import script from "./lineTable.vue?vue&type=script&lang=js&"
export * from "./lineTable.vue?vue&type=script&lang=js&"
import style0 from "./lineTable.vue?vue&type=style&index=0&id=28d85eca&prod&lang=scss&scoped=true&"
import style1 from "./lineTable.vue?vue&type=style&index=1&id=28d85eca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d85eca",
  null
  
)

export default component.exports